import { render } from "./Notifikation.vue?vue&type=template&id=a8155fbc&scoped=true"
import script from "./Notifikation.vue?vue&type=script&lang=js"
export * from "./Notifikation.vue?vue&type=script&lang=js"

import "./Notifikation.vue?vue&type=style&index=0&id=a8155fbc&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8155fbc"]])

export default __exports__